// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.params-container {
  display: grid;
  grid-template-rows: auto;
  grid-gap: 0.5rem;
  padding: 1rem;
  width: 100%;
}
.params-container .param {
  display: grid;
  grid-template-columns: 11rem max-content max-content 24px;
  grid-gap: 0.5rem;
  margin: auto 0;
  padding: 0.7rem;
  background-color: rgba(114, 191, 68, 0.0901960784);
  border-radius: 2px;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 0 1px 0px 1px rgba(0, 0, 0, 0.04), 0 3px 0px -3px rgba(0, 0, 0, 0.12);
}
.params-container .param:focus-within {
  transform: scale(1.005);
}
.params-container .param.invalid {
  background-color: rgba(250, 177, 177, 0.27);
}
.params-container .param label {
  margin: auto 0;
  font-weight: bold;
}
.params-container .param input {
  z-index: 10;
  border: 1px solid #dfe0e1;
  border-radius: 5px;
  line-height: 1.5rem;
}
.params-container .param .param-value {
  margin: auto 0;
  text-align: center;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-size: 1rem;
}
.params-container .param .param-stored {
  color: grey;
  font-style: italic;
  margin: auto;
  max-height: 28px;
  text-align: right;
  margin-left: 2rem;
}
.params-container .param .param-validation {
  max-height: 200px;
  opacity: 1;
  margin: 0 auto;
  transition: max-height 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease-in-out, color 0.5s ease-in-out, margin 0.5s ease-in-out;
  color: lightcoral;
  font-style: italic;
  font-size: 0.8rem;
}
.params-container .param .param-validation.collapsed {
  color: lightgreen;
  max-height: 0;
  opacity: 0;
  margin: -30px auto 0 auto;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-preview {
  box-sizing: border-box;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  background-color: rgba(114, 191, 68, 0.0901960784);
  display: grid;
  grid-template-columns: 9rem 6rem auto 24px;
  grid-gap: 0.5rem;
  margin: auto 0;
  padding: 0.7rem;
  border-radius: 2px;
  cursor: move;
}
.cdk-drag-preview.invalid {
  background-color: rgba(250, 177, 177, 0.27);
}
.cdk-drag-preview label {
  margin: auto 0;
  font-weight: bold;
}
.cdk-drag-preview input {
  line-height: 1.5rem;
  border: none;
  background: transparent;
  text-align: center !important;
}
.cdk-drag-preview .param-value {
  margin: auto 0;
  text-align: center;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-size: 1rem;
}
.cdk-drag-preview .param-stored {
  color: grey;
  font-style: italic;
  margin: auto;
  max-height: 28px;
  text-align: right;
  margin-left: 2rem;
}
.cdk-drag-preview .param-validation {
  max-height: 200px;
  opacity: 1;
  margin: 0 auto;
  color: lightcoral;
  font-style: italic;
  font-size: 0.8rem;
}
.cdk-drag-preview .param-validation.collapsed {
  max-height: 0;
  opacity: 0;
}

.readonly {
  color: #888 !important;
}

.param-handle {
  color: #888;
  opacity: 0.2;
  cursor: move;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.param-handle:hover {
  transform: scale(1.25);
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-structure/global-settings/global-settings.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,yDAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kDAAA;EACA,kBAAA;EACA,mHAAA;AACJ;AACI;EACE,uBAAA;AACN;AAEI;EACE,2CAAA;AAAN;AAGI;EACE,cAAA;EACA,iBAAA;AADN;AAII;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAFN;AAKI;EACE,cAAA;EACA,kBAAA;EACA,qDAAA;EACA,eAAA;AAHN;AAMI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAJN;AAOI;EAEE,iBAAA;EACA,UAAA;EACA,cAAA;EACA,2IAAA;EAEA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAPN;AAQM;EACE,iBAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;AANR;;AAYA;EACE,UAAA;AATF;;AAYA;EACE,sDAAA;AATF;;AAYA;EACE,sDAAA;AATF;;AAYA;EACE,sBAAA;EACA,qHAAA;EACA,kDAAA;EAMA,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAdF;AAIE;EACE,2CAAA;AAFJ;AAaE;EACE,cAAA;EACA,iBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;AAZJ;AAeE;EACE,cAAA;EACA,kBAAA;EACA,qDAAA;EACA,eAAA;AAbJ;AAgBE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAfJ;AAgBI;EACE,aAAA;EACA,UAAA;AAdN;;AAmBA;EACE,sBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,4DAAA;AAhBF;AAiBE;EACE,sBAAA;EACA,YAAA;AAfJ","sourcesContent":[".params-container {\r\n  display: grid;\r\n  grid-template-rows: auto;\r\n  grid-gap: 0.5rem;\r\n  padding: 1rem;\r\n  width: 100%;\r\n\r\n  .param {\r\n    display: grid;\r\n    grid-template-columns: 11rem max-content max-content 24px;\r\n    grid-gap: 0.5rem;\r\n    margin: auto 0;\r\n    padding: 0.7rem;\r\n    background-color: #72bf4417;\r\n    border-radius: 2px;\r\n    box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2), 0 1px 0px 1px rgba(0, 0, 0, 0.04), 0 3px 0px -3px rgba(0, 0, 0, 0.12);\r\n\r\n    &:focus-within {\r\n      transform: scale(1.005);\r\n    }\r\n\r\n    &.invalid {\r\n      background-color: rgba(250, 177, 177, 0.27);\r\n    }\r\n\r\n    label {\r\n      margin: auto 0;\r\n      font-weight: bold;\r\n    }\r\n\r\n    input {\r\n      z-index: 10;\r\n      border: 1px solid #dfe0e1;\r\n      border-radius: 5px;\r\n      line-height: 1.5rem;\r\n    }\r\n\r\n    .param-value {\r\n      margin: auto 0;\r\n      text-align: center;\r\n      font-family: 'Source Sans Pro', Helvetica, sans-serif;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .param-stored {\r\n      color: grey;\r\n      font-style: italic;\r\n      margin: auto;\r\n      max-height: 28px;\r\n      text-align: right;\r\n      margin-left: 2rem;\r\n    }\r\n\r\n    .param-validation {\r\n      // z-index: -1;\r\n      max-height: 200px;\r\n      opacity: 1;\r\n      margin: 0 auto;\r\n      transition: max-height 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease-in-out, color 0.5s ease-in-out,\r\n        margin 0.5s ease-in-out;\r\n      color: lightcoral;\r\n      font-style: italic;\r\n      font-size: 0.8rem;\r\n      &.collapsed {\r\n        color: lightgreen;\r\n        max-height: 0;\r\n        opacity: 0;\r\n        margin: -30px auto 0 auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0;\r\n}\r\n\r\n.cdk-drag-animating {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n.cdk-drag-preview {\r\n  box-sizing: border-box;\r\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n  background-color: #72bf4417;\r\n\r\n  &.invalid {\r\n    background-color: rgba(250, 177, 177, 0.27);\r\n  }\r\n\r\n  display: grid;\r\n  grid-template-columns: 9rem 6rem auto 24px;\r\n  grid-gap: 0.5rem;\r\n  margin: auto 0;\r\n  padding: 0.7rem;\r\n  border-radius: 2px;\r\n  cursor: move;\r\n\r\n  label {\r\n    margin: auto 0;\r\n    font-weight: bold;\r\n  }\r\n\r\n  input {\r\n    line-height: 1.5rem;\r\n    border: none;\r\n    background: transparent;\r\n    text-align: center !important;\r\n  }\r\n\r\n  .param-value {\r\n    margin: auto 0;\r\n    text-align: center;\r\n    font-family: 'Source Sans Pro', Helvetica, sans-serif;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .param-stored {\r\n    color: grey;\r\n    font-style: italic;\r\n    margin: auto;\r\n    max-height: 28px;\r\n    text-align: right;\r\n    margin-left: 2rem;\r\n  }\r\n\r\n  .param-validation {\r\n    max-height: 200px;\r\n    opacity: 1;\r\n    margin: 0 auto;\r\n    color: lightcoral;\r\n    font-style: italic;\r\n    font-size: 0.8rem;\r\n    &.collapsed {\r\n      max-height: 0;\r\n      opacity: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.readonly {\r\n  color: #888 !important;\r\n}\r\n\r\n.param-handle {\r\n  color: #888;\r\n  opacity: 0.2;\r\n  cursor: move;\r\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  &:hover {\r\n    transform: scale(1.25);\r\n    opacity: 0.5;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
